import React, { useState } from "react";
import { StaticImage } from "gatsby-plugin-image";

// styles
import * as styles from "./Cards.module.css";

const Cards = ({ cardsData = [], onArrowClick, visibleCardCount }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isCollapsing, setIsCollapsing] = useState(false);

  const toggleExpand = () => {
    if (isExpanded) {
      // Track collapse event
      if (onArrowClick) {
        onArrowClick("Collapse Card Cta Clicked");
      }
      // Start collapsing animation
      setIsCollapsing(true);
      setTimeout(() => {
        setIsExpanded(false);
        setIsCollapsing(false);
      }, 400); // Match animation duration
    } else {
      // Track expand event
      if (onArrowClick) {
        onArrowClick("Expand Card Cta Clicked");
      }
      setIsExpanded(true);
    }
  };

  // Show {visibleCardCount} cards initially, all cards when expanded or collapsing
  const visibleCards =
    isExpanded || isCollapsing
      ? cardsData
      : cardsData.slice(0, visibleCardCount);

  return (
    <div className={styles.cardsContainer}>
      {visibleCards.map((card, index) => (
        <div
          key={card.id}
          className={`${styles.card} ${styles[`card${card.id}`]} ${
            isCollapsing && index >= 2 ? styles.cardCollapsing : ""
          }`}
        >
          {/* Desktop Layout: Step | Image | Content */}
          <div className={styles.desktopLayout}>
            <div className={styles.stepSection}>
              <div className={styles.stepText}>
                <span className={styles.stepLabel}>Step</span>
              </div>
              <div className={styles.stepIcon}>
                <img src={card.icon} alt={`Step ${card.step}`} />
              </div>
            </div>
            <div className={styles.imageSection}>
              <img
                src={card.desktopImg}
                alt={card.title}
                className={styles.cardImage}
              />
            </div>
            <div className={styles.contentSection}>
              <h3 className={styles.cardTitle}>{card.title}</h3>
              <p className={styles.cardDescription}>{card.description}</p>
            </div>
          </div>

          {/* Mobile Layout */}
          <div className={styles.mobileLayout}>
            <div className={styles.mobileImageSection}>
              <img
                src={card.mobileImg}
                alt={card.title}
                className={styles.cardImageMobile}
              />
            </div>
            <div className={styles.mobileContentSection}>
              <div className={styles.mobileStepSection}>
                <div className={styles.stepText}>
                  <span className={styles.stepLabel}>Step</span>
                </div>
                <div className={styles.stepIcon}>
                  <img src={card.icon} alt={`Step ${card.step}`} />
                </div>
              </div>
              <h3 className={styles.cardTitle}>{card.title}</h3>
              <p className={styles.cardDescription}>{card.description}</p>
            </div>
          </div>
        </div>
      ))}

      {/* Toggle Button */}
      {cardsData.length > 2 && (
        <div className={styles.toggleButtonWrapper}>
          <button
            className={styles.toggleButton}
            onClick={toggleExpand}
            aria-label={isExpanded ? "Show less" : "Show more"}
          >
            <StaticImage
              src="../../../../images/icons/down_arrw.png"
              alt="Toggle"
              placeholder="blurred"
              className={`${styles.arrowIcon} ${
                isExpanded ? styles.arrowUp : ""
              }`}
              loading="lazy"
            />
          </button>
        </div>
      )}
    </div>
  );
};

export default Cards;
